import { render, staticRenderFns } from "./SlotShortSettings.vue?vue&type=template&id=3360f842&scoped=true&"
import script from "./SlotShortSettings.vue?vue&type=script&lang=js&"
export * from "./SlotShortSettings.vue?vue&type=script&lang=js&"
import style0 from "./SlotShortSettings.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SlotShortSettings.vue?vue&type=style&index=1&id=3360f842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3360f842",
  null
  
)

export default component.exports